
import { ComputedRef, defineComponent, onMounted } from "vue";
import { useStore } from "vuex";
import { computed } from "@vue/reactivity";
import { UserRanking } from "../../../../../domain/entities/entities";
import { dispatchError } from "../../../utils/error_handling";
import { formattedDuration } from "../../mixins";
import { wrapLoading } from "../../../utils/wrap_loading";

export default defineComponent({
  name: "RankingStatistics",
  setup() {
    const store = useStore();
    onMounted(async () => {
      try {
        await wrapLoading(async () => {
          await loadUsersRanking();
        });
      } catch (e) {
        console.log("[onMounted] Error ", e);
        await dispatchError(e);
      }
    });

    const loadUsersRanking = async () => {
      try {
        await store.dispatch("userProfile_module/loadUsersRanking");
      } catch (e) {
        console.log("[loadTeams] Error ", e);
        throw e;
      }
    };

    const usersRanking: ComputedRef<UserRanking[]> = computed(
      () => store.getters["userProfile_module/usersRanking"]
    );

    return {
      formattedDuration,
      usersRanking
    };
  }
});
